module.exports = __webpack_public_path__ + "img/2024-02-13a_2.be481c21.jpg";